// extracted by mini-css-extract-plugin
export default {"lockedBanner":"Step_lockedBanner__F5zEo"};